export function formSubmitFetch(formName, async, noAuthenticationRequired) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'FORM_SUBMIT_FETCH',
                formName,
                async,
                noAuthenticationRequired,
            })
        );
}

export function formSubmitReset(formName, resetValues = true) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'FORM_SUBMIT_RESET',
                formName,
                resetValues,
            })
        );
}

export function registerForm(formName) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'FORM_REGISTER',
                formName,
            })
        );
}

export function unregisterForm(formName) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'FORM_UNREGISTER',
                formName,
            })
        );
}

export function setFieldValue(formName, fieldName, value, operator) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'FORM_SET_FIELD_VALUE',
                fieldName,
                formName,
                operator,
                value,
            })
        );
}

export function setFieldValues(formName, values, resetValues = true) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'FORM_SET_FIELD_VALUES',
                formName,
                resetValues,
                values,
            })
        );
}

export function setFormCustomPath(formName, customPath) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'SET_FORM_CUSTOM_PATH',
                formName,
                customPath,
            })
        );
}

export function unregisterFieldValue(formName, fieldName) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'FORM_UNREGISTER_FIELD_VALUE',
                fieldName,
                formName,
            })
        );
}

export function setFieldErrors(formName, fieldName, errors) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'FORM_SET_FIELD_ERRORS',
                fieldName,
                formName,
                errors,
            })
        );
}

export function unregisterFieldErrors(formName, fieldName) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'FORM_UNREGISTER_FIELD_ERRORS',
                fieldName,
                formName,
            })
        );
}

export function unregisterFormErrors(formName) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'FORM_UNREGISTER_FORM_ERRORS',
                formName,
            })
        );
}

export function setFormSubmitted(actionShouldFetch, formName, servicesDataKey, submitted) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'FORM_SUBMITTED',
                actionShouldFetch,
                formName,
                servicesDataKey,
                submitted,
            })
        );
}

export function resetForm(formName, submitted = true, resetValues = false, editing = false) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'FORM_RESET',
                formName,
                submitted: !!submitted,
                resetValues,
                editing: !!editing,
            })
        );
}

export function searchFormAddField(formName, fieldName) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'SEARCH_FORM_ADD_FIELD',
                formName,
                fieldName,
                updatePreferences: true,
            })
        );
}

export function searchFormAddFields(formName, fieldNames) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'SEARCH_FORM_ADD_FIELDS',
                formName,
                fieldNames,
                updatePreferences: true,
            })
        );
}

export function searchFormRemoveField(formName, fieldName, updatePreferences = true) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'SEARCH_FORM_REMOVE_FIELD',
                formName,
                fieldName,
                updatePreferences,
            })
        );
}

export function searchFormResetFields(formName) {
    return (dispatch) =>
        Promise.resolve(
            dispatch({
                type: 'SEARCH_FORM_RESET_FIELDS',
                formName,
                updatePreferences: true,
            })
        );
}
